<script setup lang="ts">
import {onMounted, ref} from "vue";
import { getCurrentUserBalance } from "../../../js/api/balance";
import { formatMoney as formatCurrency } from "../../../js/utils";

const loading = ref(true)
const companyBalance = ref(0);
const props = defineProps<{
  subTitle?: string,
  preloadedBalance?: number,
}>()

const loadBalance = async () => {
  loading.value = true

  try {
    companyBalance.value = await getCurrentUserBalance();
  } finally {
    loading.value = false
  }
};

onMounted(() => {
  if (props.preloadedBalance === undefined) {
    loadBalance();
  } else {
    loading.value = false;
    companyBalance.value = props.preloadedBalance;
  }
})
</script>

<template>
  <div class="card balance-card">
    <div class="balance-card__left">
      <div class="balance-card__title">
        <span>Баланс</span>
        <i class="raberu-icon-cloud-rubles color-primary balance-card__icon"/>
      </div>
      <div class="balance-card__subtitle">{{ props.subTitle ?? 'Счет компании' }}</div>
    </div>

    <div v-if="loading" class="loader"></div>
    <div v-else class="balance-card__amount">
      {{ formatCurrency(companyBalance) }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.balance-card {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__left {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    font-weight: 400;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: -4%;

     > * {
       vertical-align: middle;
     }
  }

  &__icon {
    font-size: 24px;
    margin-left: 6px;
  }

  &__subtitle {
    font-size: 12px;
    color: #888;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: -4%;
  }

  &__amount {
    font-size: 28px;
    font-weight: 500;
    letter-spacing: -0.4px;
  }
}
</style>
